import { render, staticRenderFns } from "./CompanySettingsMain.vue?vue&type=template&id=dcdadce2&"
import script from "./CompanySettingsMain.vue?vue&type=script&lang=js&"
export * from "./CompanySettingsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports